(function () {
  if (window.__sdNativeReviewsBooted) return;
  window.__sdNativeReviewsBooted = true;

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }
  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }
  function productHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  }
  function reviewAnchorId() {
    return "sofa-decor-product-reviews";
  }
  function isVisibleElement(element) {
    if (!element || !element.getBoundingClientRect) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== "none" &&
      style.visibility !== "hidden" &&
      Number(style.opacity || 1) !== 0 &&
      rect.width > 24 &&
      rect.height > 10;
  }
  function pageProductTitle() {
    var ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle && ogTitle.content) return ogTitle.content.trim();
    var title = document.title || "";
    return title.replace(/\s*[|-]\s*Sofa Decor\s*$/i, "").trim();
  }
  function findProductTitleElement() {
    var details = document.querySelector('[data-testid="product-information-details"]') ||
      document.querySelector(".product-details") ||
      document.querySelector("main");
    if (!details) return null;
    var productTitle = pageProductTitle().toLowerCase();
    var selectors = [
      '[class*="product_title"] p',
      '[class*="product_title"]',
      ".view-product-title a",
      "h1",
      "h2",
      ".text-block p",
      ".text-block"
    ];
    var seen = [];
    var candidates = [];
    selectors.forEach(function (selector) {
      qsa(details, selector).forEach(function (item) {
        if (seen.indexOf(item) === -1) {
          seen.push(item);
          candidates.push(item);
        }
      });
    });
    var match = candidates.find(function (item) {
      var text = (item.textContent || "").replace(/\s+/g, " ").trim();
      if (!text || /AUD|cart|stock|people viewing|reviews|sale|shipping/i.test(text)) return false;
      if (!isVisibleElement(item)) return false;
      var lowerText = text.toLowerCase();
      return !productTitle || productTitle.indexOf(lowerText) !== -1 || lowerText.indexOf(productTitle) !== -1 || item.className.indexOf("product_title") !== -1;
    });
    if (!match) return null;
    return match.closest(".text-block") || match.closest(".view-product-title") || match;
  }
  function productStats(dataset, handle) {
    if (!handle) return null;
    var byProduct = dataset.byProduct || {};
    var item = byProduct[handle];
    var count = item && Number(item.count || 0);
    var average = item && Number(item.average || 0);
    if (count && average) return { count: count, average: average };
    var reviews = (dataset.reviews || []).filter(function (review) {
      return review.product && review.product.handle === handle;
    });
    if (!reviews.length) return null;
    average = reviews.reduce(function (sum, review) { return sum + Number(review.rating || 0); }, 0) / reviews.length;
    return { count: reviews.length, average: average };
  }
  function ensureReviewSectionAnchor() {
    var section = document.querySelector(".sd-native-reviews[data-reviews-json]");
    if (!section) return null;
    if (!section.id) section.id = reviewAnchorId();
    return section;
  }
  function initProductPageSummary(dataset) {
    var handle = productHandleFromPath();
    if (!handle || document.querySelector(".sd-product-page-rating-link")) return;
    var stats = productStats(dataset, handle);
    if (!stats || !stats.count || !stats.average) return;
    var title = findProductTitleElement();
    if (!title || !title.parentNode) return;
    var section = ensureReviewSectionAnchor();
    if (!section) return;
    var reviewWord = stats.count === 1 ? "review" : "reviews";
    var link = document.createElement("a");
    link.className = "sd-product-page-rating-link";
    link.href = "#" + reviewAnchorId();
    link.setAttribute("aria-label", "Read " + stats.count + " verified customer " + reviewWord + " for this product");
    link.innerHTML = '' +
      '<span class="sd-product-page-rating-link__stars" aria-hidden="true">' + escapeHtml(starText(stats.average)) + '</span>' +
      '<span class="sd-product-page-rating-link__copy"><strong>' + escapeHtml(stats.average.toFixed(1)) + '</strong> from ' + escapeHtml(stats.count) + ' verified customer ' + escapeHtml(reviewWord) + '</span>' +
      '<span class="sd-product-page-rating-link__action">Read reviews</span>';
    link.addEventListener("click", function (event) {
      var target = ensureReviewSectionAnchor();
      if (!target) return;
      event.preventDefault();
      var offset = 84;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: "smooth" });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", "#" + reviewAnchorId());
      }
    });
    title.insertAdjacentElement("afterend", link);
  }
  function formatDate(value) {
    if (!value) return "";
    var parts = String(value).split(" ")[0].split("-");
    if (parts.length !== 3) return value;
    var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    return date.toLocaleDateString("en-AU", { month: "short", year: "numeric" });
  }
  function initials(name) {
    return String(name || "Verified customer").trim().split(/\s+/).slice(0, 2).map(function (part) {
      return part.charAt(0).toUpperCase();
    }).join("") || "SD";
  }
  function starTiles(rating) {
    var filled = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var html = "";
    for (var i = 1; i <= 5; i += 1) {
      html += '<span class="sd-native-review-star' + (i > filled ? ' is-empty' : '') + '" aria-hidden="true">★</span>';
    }
    return html;
  }
  function starText(rating) {
    var filled = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return "★★★★★".slice(0, filled) + "☆☆☆☆☆".slice(0, 5 - filled);
  }
  function reviewHeadline(review, copy) {
    var title = String(review.title || "").trim();
    if (title) return title;
    var sentence = String(copy || "").split(/[.!?]/)[0].trim();
    if (!sentence || sentence.length < 8) return Number(review.rating || 0) >= 5 ? "Excellent quality and fit" : "Customer experience";
    return sentence.length > 72 ? sentence.slice(0, 69).trim() + "..." : sentence;
  }
  function reviewCard(review, showProduct) {
    var mediaItems = review.media || [];
    var media = mediaItems.slice(0, 3).map(function (item, index) {
      var url = item.assetUrl || item.url || item.thumbUrl || item.originalUrl;
      if (!url) return "";
      var more = index === 2 && mediaItems.length > 3
        ? '<span class="sd-native-review-card__media-more">+' + escapeHtml(mediaItems.length - 3) + '</span>'
        : "";
      return '<span class="sd-native-review-card__media-item"><img loading="lazy" src="' + escapeHtml(url) + '" alt="' + escapeHtml("Customer photo for " + (review.product && review.product.title || "Sofa Decor review")) + '">' + more + '</span>';
    }).join("");
    var copy = review.content || "Rated " + review.rating + " out of 5 by a Sofa Decor customer.";
    var headline = reviewHeadline(review, copy);
    var product = showProduct && review.product && review.product.title
      ? '<div class="sd-native-review-card__product"><a href="' + escapeHtml(review.product.url || "#") + '">' + escapeHtml(review.product.title) + '</a></div>'
      : "";
    var proof = '' +
      '<div class="sd-native-review-card__proof">' +
        '<span class="sd-native-review-card__badge">' + (review.verified ? '✓ Verified purchase' : 'Customer review') + '</span>' +
        (review.location ? '<span class="sd-native-review-card__badge">' + escapeHtml(review.location) + '</span>' : '') +
        (mediaItems.length ? '<span class="sd-native-review-card__badge sd-native-review-card__badge--photo">Photo review</span>' : '') +
      '</div>';
    return '' +
      '<article class="sd-native-review-card" data-rating="' + escapeHtml(review.rating) + '">' +
        '<div class="sd-native-review-card__top">' +
          '<div class="sd-native-review-card__stars" aria-label="' + escapeHtml(review.rating + ' out of 5 stars') + '">' + starTiles(review.rating) + '</div>' +
          '<div class="sd-native-review-card__date">' + escapeHtml(formatDate(review.date)) + '</div>' +
        '</div>' +
        '<h3 class="sd-native-review-card__headline">' + escapeHtml(headline) + '</h3>' +
        '<p class="sd-native-review-card__copy">' + escapeHtml(copy) + '</p>' +
        (media ? '<div class="sd-native-review-card__media">' + media + '</div>' : '') +
        proof +
        '<div class="sd-native-review-card__footer">' +
          '<div class="sd-native-review-card__author">' +
            '<div class="sd-native-review-card__avatar">' + escapeHtml(initials(review.author)) + '</div>' +
            '<div><div class="sd-native-review-card__name">' + escapeHtml(review.author || "Verified customer") + '</div>' +
            '<div class="sd-native-review-card__meta">Sofa Decor customer</div></div>' +
          '</div>' +
          product +
        '</div>' +
        (review.itemType ? '<div class="sd-native-review-card__meta">' + escapeHtml(review.itemType) + '</div>' : '') +
      '</article>';
  }
  function chooseReviews(section, dataset) {
    var mode = section.getAttribute("data-review-mode") || "auto";
    var currentHandle = productHandleFromPath();
    var reviews = dataset.reviews || [];
    if ((mode === "product" || mode === "auto") && currentHandle) {
      var productReviews = reviews.filter(function (review) {
        return review.product && review.product.handle === currentHandle;
      });
      if (productReviews.length) return { reviews: productReviews, productMode: true };
      if (section.getAttribute("data-fallback") !== "all") return { reviews: [], productMode: true };
    }
    return { reviews: reviews, productMode: false };
  }
  function setProductReviewSummaryState(section, state, reviews) {
    if (section.getAttribute("data-product-reviews") !== "true") return;
    var ready = state === "ready";
    var summary = section.querySelector("[data-sd-product-review-summary]");
    var photoPill = section.querySelector("[data-sd-product-photo-reviews]");
    if (summary) {
      summary.hidden = !ready;
      summary.style.display = ready ? "" : "none";
    }
    if (photoPill) {
      var hasPhotos = ready && reviews.some(function (review) {
        return Array.isArray(review.media) && review.media.some(function (item) {
          return item && (item.assetUrl || item.url || item.thumbUrl || item.originalUrl);
        });
      });
      photoPill.hidden = !hasPhotos;
      photoPill.style.display = hasPhotos ? "" : "none";
    }
    section.setAttribute("data-review-state", state);
  }
  function init(section, dataset) {
    setProductReviewSummaryState(section, "pending");
    var selected = chooseReviews(section, dataset);
    var totalReviews = selected.reviews;
    var reviews = totalReviews.slice();
    var track = section.querySelector("[data-sd-reviews-track]");
    var count = section.querySelector("[data-sd-review-count]");
    var score = section.querySelector("[data-sd-review-score]");
    var stars = section.querySelector("[data-sd-review-stars]");
    if (!track || !reviews.length) {
      section.setAttribute("data-empty", "true");
      setProductReviewSummaryState(section, "empty");
      return;
    }
    var avg = totalReviews.reduce(function (sum, review) { return sum + Number(review.rating || 0); }, 0) / totalReviews.length;
    track.innerHTML = reviews.map(function (review) { return reviewCard(review, !selected.productMode); }).join("");
    if (count) count.textContent = String(totalReviews.length);
    if (score) score.textContent = avg.toFixed(1);
    if (stars) stars.innerHTML = starTiles(avg);
    section.setAttribute("data-empty", "false");
    if (section.getAttribute("data-product-reviews") === "true") {
      var handle = section.getAttribute("data-product-handle");
      var validProductSummary = selected.productMode && totalReviews.every(function (review) {
        var rating = review && Number(review.rating);
        return review && review.product && review.product.handle === handle &&
          Number.isFinite(rating) && rating >= 1 && rating <= 5;
      });
      setProductReviewSummaryState(section, validProductSummary ? "ready" : "unavailable", totalReviews);
    }
    var prev = section.querySelector("[data-sd-review-prev]");
    var next = section.querySelector("[data-sd-review-next]");
    function move(direction) {
      var card = track.querySelector(".sd-native-review-card");
      var width = card ? card.getBoundingClientRect().width + 14 : 320;
      track.scrollBy({ left: direction * width, behavior: "smooth" });
    }
    if (prev) prev.addEventListener("click", function () { move(-1); });
    if (next) next.addEventListener("click", function () { move(1); });
  }
  function cleanBadgeText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }
  function normaliseBadgeText(value) {
    return cleanBadgeText(value).toLowerCase();
  }
  function titleTextFromBadge(badge) {
    var title = badge.getAttribute("data-product-title") || badge.getAttribute("data-sd-product-title") || "";
    if (title) return normaliseBadgeText(title);
    var label = badge.getAttribute("aria-label") || "";
    var match = label.match(/\bfor\s+(.+)$/i);
    return match ? normaliseBadgeText(match[1]) : "";
  }
  function isCardTitleCandidate(item, badge, expectedTitle) {
    if (!item || item === badge || item.contains(badge) || badge.contains(item)) return false;
    if (item.closest(".sd-product-card-rating, form, product-form-component, [class*='quick-add'], [class*='QuickAdd'], button, [role='button']")) return false;
    var text = cleanBadgeText(item.textContent);
    if (!text) return false;
    if (/add to cart|quick add|select options|sold out|unavailable|people viewing|aud|\$\s*\d|save|sale|off|review|rating|star|tax|shipping/i.test(text)) return false;
    var lower = normaliseBadgeText(text);
    if (expectedTitle && (expectedTitle.indexOf(lower) !== -1 || lower.indexOf(expectedTitle) !== -1)) return true;
    var className = String(item.className || "");
    return /product[_-]?title|view-product-title|title/i.test(className) || /^H[1-6]$/.test(item.tagName || "");
  }
  function scoreCardTitleCandidate(item, expectedTitle) {
    var score = 0;
    var text = normaliseBadgeText(item.textContent);
    var className = String(item.className || "");
    if (expectedTitle && (expectedTitle.indexOf(text) !== -1 || text.indexOf(expectedTitle) !== -1)) score += 100;
    if (/product[_-]?title|view-product-title|title/i.test(className)) score += 40;
    if (/^H[1-6]$/.test(item.tagName || "")) score += 25;
    if (item.closest(".text-block")) score += 10;
    if (text.length >= 8 && text.length <= 140) score += 10;
    return score;
  }
  function placeBadgeNearTitle(badge) {
    var card = badge.closest(".product-card__link") ||
      badge.closest("product-card-link") ||
      badge.closest("product-card") ||
      badge.closest(".product-grid__item") ||
      badge.parentElement;
    if (!card) return;

    var expectedTitle = titleTextFromBadge(badge);
    var content = card.querySelector(".group-block-content") || card;
    var selectors = [
      "[data-product-title]",
      "[class*='product_title']",
      ".view-product-title",
      ".product-card-title",
      ".product-title",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      ".text-block",
      "p"
    ];
    var seen = [];
    var candidates = [];
    selectors.forEach(function (selector) {
      qsa(content, selector).forEach(function (item) {
        if (seen.indexOf(item) === -1 && isCardTitleCandidate(item, badge, expectedTitle)) {
          seen.push(item);
          candidates.push(item);
        }
      });
    });
    candidates.sort(function (a, b) {
      return scoreCardTitleCandidate(b, expectedTitle) - scoreCardTitleCandidate(a, expectedTitle);
    });

    var targetTitle = candidates[0] || null;
    if (!targetTitle) {
      var details = card.querySelector(".product-grid-view-zoom-out--details");
      if (details) targetTitle = details.querySelector("h1, h2, h3, h4, h5, h6, p, .text-block");
    }
    if (!targetTitle || !targetTitle.parentNode) return;

    var insertionTarget = targetTitle.closest("[class*='product_title']") ||
      targetTitle.closest(".view-product-title") ||
      targetTitle.closest(".text-block") ||
      targetTitle;
    if (!insertionTarget || !insertionTarget.parentNode) return;
    if (insertionTarget.nextElementSibling === badge) {
      badge.setAttribute("data-sd-rating-placement", "title");
      return;
    }
    insertionTarget.insertAdjacentElement("afterend", badge);
    badge.setAttribute("data-sd-rating-placement", "title");
  }

  
  function handleFromElement(element) {
    var handle = element.getAttribute("data-product-handle") || "";
    if (handle) return handle;
    var link = element.closest("a[href*='/products/']") ||
      (element.closest("product-card, product-card-link, .product-grid__item") || document).querySelector("a[href*='/products/']");
    if (!link) return "";
    var match = String(link.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  }
  function productStatsForId(dataset, productId) {
    if (!productId) return null;
    var reviews = (dataset.reviews || []).filter(function (review) {
      return review.product && String(review.product.id || "") === String(productId);
    });
    if (!reviews.length) return null;
    var average = reviews.reduce(function (sum, review) { return sum + Number(review.rating || 0); }, 0) / reviews.length;
    return {
      count: reviews.length,
      average: average,
      handle: reviews[0].product && reviews[0].product.handle || ""
    };
  }
  function productStatsForBadge(dataset, badge) {
    var byProduct = dataset.byProduct || {};
    var handle = handleFromElement(badge);
    var item = handle && byProduct[handle];
    if (item && Number(item.count || 0) && Number(item.average || 0)) {
      if (!badge.getAttribute("data-product-handle")) badge.setAttribute("data-product-handle", handle);
      return { count: Number(item.count || 0), average: Number(item.average || 0), handle: handle };
    }
    var card = badge.closest("[data-product-id]");
    var stats = productStatsForId(dataset, card && card.getAttribute("data-product-id"));
    if (stats && stats.handle && !badge.getAttribute("data-product-handle")) badge.setAttribute("data-product-handle", stats.handle);
    return stats;
  }
  function initProductBadges(dataset, root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = qsa(scope, "[data-product-review-badge]");
    if (scope !== document && scope.matches && scope.matches("[data-product-review-badge]")) badges.unshift(scope);
    if (!badges.length) return 0;
    var updated = 0;
    badges.forEach(function (badge) {
      if (badge.getAttribute("data-sd-rating-ready") === "true") {
        placeBadgeNearTitle(badge);
        badge.hidden = false;
        updated += 1;
        return;
      }
      var stats = productStatsForBadge(dataset, badge);
      var handle = stats && stats.handle || badge.getAttribute("data-product-handle") || "";
      var count = stats && Number(stats.count || 0);
      var avg = stats && Number(stats.average || 0);
      if (!count || !avg) {
        badge.hidden = true;
        return;
      }
      var stars = badge.querySelector("[data-sd-card-stars]");
      var score = badge.querySelector("[data-sd-card-score]");
      var countEl = badge.querySelector("[data-sd-card-count]");
      if (stars) stars.textContent = starText(avg);
      if (score) score.textContent = avg.toFixed(1);
      if (countEl) countEl.textContent = "(" + count + " " + (count === 1 ? "review" : "reviews") + ")";
      badge.setAttribute("aria-label", avg.toFixed(1) + " out of 5 from " + count + " " + (count === 1 ? "review" : "reviews"));
      badge.setAttribute("data-sd-rating-ready", "true");
      placeBadgeNearTitle(badge);
      badge.hidden = false;
      updated += 1;
    });
    return updated;
  }
  function relocateReadyProductBadges(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = qsa(scope, "[data-product-review-badge]");
    if (scope !== document && scope.matches && scope.matches("[data-product-review-badge]")) badges.unshift(scope);
    badges.forEach(function (badge) {
      if (badge.getAttribute("data-sd-rating-ready") === "true") {
        placeBadgeNearTitle(badge);
        badge.hidden = false;
      }
    });
  }
  function watchReadyProductBadgePlacement() {
    relocateReadyProductBadges(document);
    [100, 400, 1200, 2600, 5000].forEach(function (delay) {
      window.setTimeout(function () { relocateReadyProductBadges(document); }, delay);
    });
    if (window.__sdNativeReviewsReadyBadgeObserver || !("MutationObserver" in window) || !document.body) return;
    var timer = null;
    var observer = new MutationObserver(function (mutations) {
      var needsRefresh = false;
      for (var i = 0; i < mutations.length && !needsRefresh; i += 1) {
        var mutation = mutations[i];
        for (var j = 0; j < mutation.addedNodes.length; j += 1) {
          var node = mutation.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;
          if ((node.matches && node.matches("[data-product-review-badge], product-card, product-card-link, .product-grid__item, .resource-list__item")) ||
            (node.querySelector && node.querySelector("[data-product-review-badge]"))) {
            needsRefresh = true;
            break;
          }
        }
      }
      if (!needsRefresh) return;
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        timer = null;
        relocateReadyProductBadges(document);
      }, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__sdNativeReviewsReadyBadgeObserver = observer;
  }
  function watchDynamicProductBadges(dataset) {
    if (window.__sdNativeReviewsBadgeObserver) return;
    var timer = null;
    function refresh(root) {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        timer = null;
        initProductBadges(dataset, root || document);
      }, 80);
    }
    if ("MutationObserver" in window && document.body) {
      var observer = new MutationObserver(function (mutations) {
        var needsRefresh = false;
        for (var i = 0; i < mutations.length && !needsRefresh; i += 1) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j += 1) {
            var node = mutation.addedNodes[j];
            if (!node || node.nodeType !== 1) continue;
            if ((node.matches && node.matches("[data-product-review-badge], product-card, product-card-link, .product-grid__item, .resource-list__item")) ||
              (node.querySelector && node.querySelector("[data-product-review-badge]"))) {
              needsRefresh = true;
              break;
            }
          }
        }
        if (needsRefresh) refresh(document);
      });
      observer.observe(document.body, { childList: true, subtree: true });
      window.__sdNativeReviewsBadgeObserver = observer;
    }
    ["shopify:section:load", "shopify:section:reorder", "shopify:block:select", "shopify:section:select", "theme:collection:updated", "collection:updated"].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        refresh(event.target || document);
      });
    });
    window.addEventListener("pageshow", function () { refresh(document); });
    window.addEventListener("resize", function () { refresh(document); });
    refresh(document);
  }
  function boot() {
    var sections = qsa(document, ".sd-native-reviews[data-reviews-json]");
    var badges = qsa(document, "[data-product-review-badge]");
    if (!sections.length && !badges.length) return;
    watchReadyProductBadgePlacement();
    var source = sections[0] || badges[0];
    var url = source.getAttribute("data-reviews-json");
    if (!url) return;
    fetch(url, { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (dataset) {
        sections.forEach(function (section) { init(section, dataset); });
        initProductBadges(dataset);
        watchDynamicProductBadges(dataset);
        initProductPageSummary(dataset);
      })
      .catch(function () {
        sections.forEach(function (section) {
          section.setAttribute("data-empty", "true");
          setProductReviewSummaryState(section, "unavailable");
        });
      });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
